// import { List, ListItem, ListItemText } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '@material-ui/core'
// import Chart from 'react-apexcharts';
import "../styles/AdminPage.css"
import axios from 'axios';
import { useHistory } from 'react-router-dom'
import { ApiURL } from '../constants/ApiUrl'
import { useSelector } from 'react-redux'
import { Bar, Pie } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import axiosInstance from '../services/AxiosInstance';

// import { textAlign } from '@mui/system';
// import { CenterFocusStrongOutlined } from '@mui/icons-material';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);
// import Paper from '@material-ui/core/Paper';
// import {
//     ArgumentAxis,
//     ValueAxis,
//     Chart,
//     BarSeries,
// } from '@devexpress/dx-react-chart-material-ui';
// import Loader from '../component/loader/loader'

function AdminPage() {

    


    const opInitial = {
        chart: {
            id: 'apexchart-example'
        },
        xaxis: {
            categories: []
        }
    }

    const seriesInitial = [{
        name: 'series-1',
        data: []
    },]

    const [chartData, setChartData] = useState()
    const [data, setData] = useState()
    const [series, setseries] = useState()
    const [newApplicantsByState, setNewApplicantsByState] = useState([])
    const [chartMetric, setChartMetric] = useState("members")
    const [GenderList,setGenderList]=useState([])

    const [NewApp, setNewApp] = useState(0)
    const [MemberCount, setMemberCount] = useState(0)
    const [studentsApp, setStudentsApp] = useState(0)
    const [studentCount, setStudentCount] = useState(0)
    const [Associat, setAssociat] = useState(0)
    const [SortList, setSortList] = useState([])
    const history = useHistory();
    const [loader, setLoader] = useState(false)
    const user = useSelector(state => state.LoginReducer.user)

    useEffect(() => {
       

        const labelsforpie = [];
        const dataforpie = [];

        setLoader(true);
        async function getNewApp() {
            const result = await axiosInstance.get(`${ApiURL}/api/get_member_stats`);
            
            
            if (result.data.data.length === 0)
                return;
            if (result.data.data.length > 0) {
                if (result.data.data[0].total)
                    setNewApp(result.data.data[0].total) //New Applicants

                if (result.data.data[3].total)
                    setMemberCount(result.data.data[3].total) // Life Members
                if (result.data.data[1].total)
                    setStudentsApp(result.data.data[1].total) // New Student Applicants
                if (result.data.data[2].total)
                    setStudentCount(result.data.data[2].total) // Student Members
                if (result.data.data[4].total)
                    setAssociat(result.data.data[4].total) // Associate Members
            }
            else {
                setNewApp(0)
                setMemberCount(0)
                setStudentsApp(0)
                setStudentCount(0)
                setAssociat(0)
            }
            // labelsforpie[] = ["Life Members", "Student Members", "Associate Members"]
            // dataforpie = [MemberCount, studentCount, Associat ]
            // setpieLabel(labelsforpie);
            // setpieData(dataforpie);
            // setGraph.labels(pieLabel);
            // setGraph.data(pieData)

            // if(result.data.data.length > 1){
            //     // if(result.data.data[0]._id === true){
            //         setMemberCount(dresult.data.data[4].total)
            //         setNewApp(result.data.data[3].total)
            //         setStudentsApp(result.data[1].total)
            //     }
            //     // else{
            //     //     // setMemberCount(result.data.data[1].total)
            //     //     // setNewApp(result.data.data[0].total)
            //     // }
            // // }
            // else
            // {
            //     if(result.data.data[0]._id === true){
            //         setMemberCount(result.data.data[0].total);
            //         setNewApp(0);
            //     }
            //     else
            //     {
            //         // setMemberCount(0);
            //         setNewApp(result.data.data[0].total);
            //     }
            // }
            const result2 = await axiosInstance.post(`${ApiURL}/api/sortByStates`, { "group": "address.state" });
            setSortList(result2.data.data);
            const data = [];
            const series = [];
            const newApplicantsData = [];
            result2.data.data.forEach(element => {
                // skip records without a state name (empty or null _id)
                if (!element._id) return;
                series.push(element._id)
                data.push(element.total)
                newApplicantsData.push(element.newApplicants || 0)
            })
            setNewApplicantsByState(newApplicantsData);
            const result1=await axiosInstance.get(`${ApiURL}/api/getGenderMembersCount`);
            const count=[]
            count.push(result1.data.female)
            count.push(result1.data.male)
            count.push(result1.data.others)
            setGenderList(count)
            setData(data);
            setseries(series);
            setLoader(false);

        }
        
        getNewApp();
        // genderCount()
    },[])
    
    return (
        <div className="adminDashboard">
            <h1>Welcome to NMO Membership Portal</h1>
            <div className="statsContainer">
                <Card className="homeStats" onClick={() => { (user.role === 'Admin') ? history.push('/admin/applications') : console.log("Skip"); }}>
                    <CardContent className="homeStatsContent">
                        <h3>New Applications</h3>
                        <h1>{NewApp}</h1>
                    </CardContent>
                </Card>
                <Card className="homeStats" onClick={() => { (user.role === 'Admin') ? history.push('/admin/members') : console.log("Skip"); }}>
                    <CardContent className="homeStatsContent">
                        <h3>Life Members</h3>
                        <h1>{MemberCount}</h1>
                    </CardContent>
                </Card>
                <Card className="homeStats" onClick={() => { (user.role === 'Admin') ? history.push('/admin/applications') : console.log("Skip"); }}>
                    <CardContent className="homeStatsContent">
                        <h3>Students Applications</h3>
                        <h1>{studentsApp}</h1>
                    </CardContent>
                </Card>
                <Card className="homeStats" onClick={() => { (user.role === 'Admin') ? history.push('/admin/members') : console.log("Skip"); }}>
                    <CardContent className="homeStatsContent">
                        <h3>Students Members</h3>
                        <h1>{studentCount}</h1>
                    </CardContent>
                </Card>
                <Card className="homeStats" onClick={() => { (user.role === 'Admin') ? history.push('/admin/members') : console.log("Skip"); }}>
                    <CardContent className="homeStatsContent">
                        <h3>Associate Members</h3>
                        <h1>{Associat}</h1>
                    </CardContent>
                </Card>
            </div>
            {/* <h2>NMO State-wise Members</h2> */}
            {/* <Paper variant="outlined" square>
                <Chart
                    data={data}
                >
                    <ArgumentAxis 
                    data = {data}/>
                    <ValueAxis />

                    <BarSeries valueField="value" argumentField="argument" />
                </Chart>
            </Paper> */}

            <div className="App">
                <h1>NMO State-wise Members</h1>
                <div style={{ display: "flex", justifyContent: "center", gap: "24px", marginBottom: "16px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                        <input
                            type="radio"
                            name="chartMetric"
                            value="members"
                            checked={chartMetric === "members"}
                            onChange={() => setChartMetric("members")}
                            style={{ width: "auto", margin: 0, display: "inline-block" }}
                        />
                        Number of members
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                        <input
                            type="radio"
                            name="chartMetric"
                            value="newApplicants"
                            checked={chartMetric === "newApplicants"}
                            onChange={() => setChartMetric("newApplicants")}
                            style={{ width: "auto", margin: 0, display: "inline-block" }}
                        />
                        New applicants
                    </label>
                </div>
                <div style={{ maxWidth: "950px", marginLeft: '110px' }} >
                    <Bar right="10px"
                        data={{
                            labels: series,
                            datasets: [
                                {
                                    label: chartMetric === "members" ? "Number of members" : "New applicants",
                                    data: chartMetric === "members" ? data : newApplicantsByState,
                                    backgroundColor: [chartMetric === "members" ? "#4869B0" : "#e89b40"],
                                    borderColor: ["white"],
                                    borderWidth: 0.5,
                                },
                            ],
                        }}
                        // Height of graph
                        height={400}
                        options={{
                            maintainAspectRatio: false,
                            scales: {
                                yAxes: [
                                    {
                                        ticks: {
                                            // The y-axis value will start from zero
                                            beginAtZero: true,
                                        },
                                    },
                                ],
                            },
                            title: {
                                display: true,
                                text: 'Chart.js Bar Chart',
                            },
                            legend: {
                                labels: {
                                    fontSize: 25,
                                },
                            },
                        }}
                    />
                </div>
            </div>
            <div style={{display:'flex'}}>
            <div style={{ height: '350px', width: '350px', margin: '0 auto'}}>
                <h2>NMO Total Members</h2>
                <Pie right="50px"

                    data={{
                        // Name of the variables on x-axies for each bar
                        // labels: ["1st bar", "2nd bar", "3rd bar", "4th bar"],
                        labels: ["Life Members","Students Members","Associate Members"],
                        datasets: [
                            {
                                // Label for bars
                                label: "Number of Members",
                                // Data or value of your each variable
                                // data: [1552, 1319, 613, 1400],
                                data: [MemberCount,studentCount,Associat],
                                // Color of each bar
                                backgroundColor: ['#4869B0', '#e89b40', '#800000' ],
                                // Border color of each bar
                                borderColor: ["black"],
                                borderWidth: 0.5,
                            },
                        ],
                    }}
                    // Height of graph
                    height={400}
                    options={{
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        // The y-axis value will start from zero
                                        beginAtZero: true,
                                    },
                                },
                            ],
                        },
                        title: {
                            display: true,
                            text: 'Chart.js Pie Chart',
                        },
                        legend: {
                            labels: {
                                fontSize: 25,
                            },
                        },
                    }}
                />
            </div>
            <div style={{ height: '350px', width: '350px', margin: '0 auto'}}>
                <h2>Member Gender Diversity</h2>
                <Pie right="50px" type='Doughnut'

                    data={{
                        // Name of the variables on x-axies for each bar
                        // labels: ["1st bar", "2nd bar", "3rd bar", "4th bar"],
                        labels: ["Female","Male","Others"],
                        datasets: [
                            {
                                // Label for bars
                                label: "Number of Members",
                                // Data or value of your each variable
                                // data: [1552, 1319, 613, 1400],
                                data: GenderList,
                                // Color of each bar
                                backgroundColor: ["#778899",'#e89b40', '#66cdaa'  ],
                                // Border color of each bar
                                borderColor: ["black"],
                                borderWidth: 0.5,
                            },
                        ],
                    }}
                    // Height of graph
                    height={400}
                    options={{
                        responsive:true,
                        maintainAspectRatio: true,
                        plugins:{
                            labels:{
                                render:'percentage',
                                fontColor:['green','white','red'],
                                precision:2
                            }
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        // The y-axis value will start from zero
                                        beginAtZero: true,
                                    },
                                },
                            ],
                        },
                        title: {
                            display: true,
                            text: 'Chart.js Pie Chart',
                        },
                        legend: {
                            labels: {
                                fontSize: 25,
                            },
                        },
                    }}
                />
            </div>
            </div>
           


            {/* <div className="app">
                <div className="row">
                     <div className="mixed-chart">
                            <Chart options={chartData.options} series={chartData.series} type="bar" width={1000} height={520} />                          */}

            {/* <table className="statsTable">
                                <thead>
                                    <tr>
                                        <th>NMO State</th>
                                        <th>Number of Members</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        SortList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item._id}</td>
                                                <td>{item.total}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table> */}
            {/* </div>
                    </div>
                </div> */}
        </div>
    )
}

export default AdminPage
